/**
 * Clickable header row of the Manual Actions bucket card: warning icon, label, total count
 * (always visible, even at 0) and a chevron that reflects the popup's open state. It is the
 * floating-ui reference element, so open/close (click + keyboard) is driven by the trigger props.
 */
import { observer } from "mobx-react";
import { Ref } from "react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import IconChevronDown from "../../../../../../components/icons/icon-chevron-down/icon-chevron-down";
import IconManualActionsAlert from "../../../../../../components/icons/icon-manual-actions-alert/icon-manual-actions-alert";

interface IProps {
    label: string;
    total: number;
    open: boolean;
    disabled: boolean;
    triggerRef: Ref<HTMLDivElement>;
    triggerProps: Record<string, unknown>;
}

const RmaListManualActionsBucketCardRow: React.FC<IProps> = observer(({ label, total, open, disabled, triggerRef, triggerProps }) => (
    <div
        ref={triggerRef}
        role="button"
        tabIndex={disabled ? -1 : 0}
        className="rma-list-manual-actions-bucket__row"
        {...triggerProps}
    >
        <span className="rma-list-manual-actions-bucket__icon">
            <IconManualActionsAlert color="var(--color-neutral-10)" />
        </span>
        <FontBody2>{label}</FontBody2>
        <span className="rma-list-manual-actions-bucket__count">{total}</span>
        <span className={`rma-list-manual-actions-bucket__chevron${open ? " open" : ""}`}>
            <IconChevronDown color="var(--color-primary-2-50)" />
        </span>
    </div>
));

export default RmaListManualActionsBucketCardRow;
